import(/* webpackMode: "eager" */ "/app/hub/src/app/iframe/[accountId]/error.tsx");
